import sendRequest from './sendRequest';
var TIMEFRAMES_QUERY = "query me {\n  me {\n    team {\n      timeframes\n    }\n  }\n}\n";
var getTimeframes = function (token) {
    return sendRequest({
        query: TIMEFRAMES_QUERY,
        token: token,
    });
};
export default getTimeframes;
